import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer style={{
      background: 'var(--bg-secondary)',
      borderTop: '1px solid var(--border-light)',
      padding: '80px 0 40px 0'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          marginBottom: '48px'
        }}>
          {/* About Section */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>
              JSX International
            </h3>
            <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: '24px' }}>
              {language === 'fr'
                ? 'Solutions d\'élite pour des opérations mondiales sensibles. Un réseau mondial, une exécution locale, une discrétion absolue.'
                : 'Elite solutions for sensitive global operations. A global network, local execution, absolute discretion.'}
            </p>
            
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>
              HENRY & GABY
            </h3>
            <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: '24px' }}>
              {language === 'fr'
                ? 'Club d\'affaires privé Paris. Séjours d\'exceptions atypiques, en jet privé partout dans le monde. Un lieu d\'exception réservé à une élite discernée, où le luxe et l\'exclusivité se rencontrent.'
                : 'Private business club Paris. Exceptional atypical stays, by private jet worldwide. An exceptional place reserved for a discerning elite, where luxury and exclusivity meet.'}
            </p>
            
            <p className="body-small" style={{ color: 'var(--text-light)', lineHeight: 1.6 }}>
              {language === 'fr' ? 'Exploité par Sapphire Jets' : 'Operated by Sapphire Jets'}<br />
              996 Maine Ave Sw, Ste 733<br />
              Washington, District of Columbia, 20024, United States
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '16px' }}>
              {t.footer.quickLinks}
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <li>
                <Link to="/" className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}>
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/services" className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}>
                  {t.nav.services}
                </Link>
              </li>
              <li>
                <Link to="/membership" className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}>
                  {t.nav.membership}
                </Link>
              </li>
              <li>
                <Link to="/events" className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}>
                  {t.nav.events}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}>
                  {t.nav.contact}
                </Link>
              </li>
              <li>
                <Link to="/member-login" className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}>
                  {language === 'fr' ? 'Mon Compte' : 'My Account'}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '16px' }}>
              {t.footer.contact}
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Phone size={16} style={{ color: 'var(--text-secondary)' }} />
                <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  France : <a href="tel:+33641664258" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>+33 6 41 66 42 58</a>
                </span>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Phone size={16} style={{ color: 'var(--text-secondary)' }} />
                <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  USA : <a href="tel:+12025064111" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>+1 202-506-4111</a>
                </span>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={16} style={{ color: 'var(--text-secondary)' }} />
                <a href="mailto:contact@henry-and-gaby.com" className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  wordBreak: 'break-word'
                }}>
                  contact@henry-and-gaby.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p className="body-small" style={{ color: 'var(--text-light)' }}>
            © 2025 JSX International & Henry & Gaby. {t.footer.rights}
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <Link to="/legal" className="body-small" style={{
              color: 'var(--text-light)',
              textDecoration: 'none',
              transition: 'color 0.2s ease'
            }}>
              {t.footer.legal}
            </Link>
            <a href="#" className="body-small" style={{
              color: 'var(--text-light)',
              textDecoration: 'none',
              transition: 'color 0.2s ease'
            }}>
              {t.footer.privacy}
            </a>
            <Link to="/terms" className="body-small" style={{
              color: 'var(--text-light)',
              textDecoration: 'none',
              transition: 'color 0.2s ease'
            }}>
              {t.footer.terms}
            </Link>
          </div>
        </div>
      </div>

      <style jsx>{`
        footer a:hover {
          color: var(--text-primary) !important;
        }
      `}</style>
    </footer>
  );
};

export default Footer;